<template>
    <div class="guide-answer-wrapper" :class="{ 'can-hide-mode': !isEmpty }">
        <div class="widget-title" v-if="isEmpty">{{ selectLabel }}</div>
        <Button v-if="!isEmpty" :text="addLabel" :icon="addIcon" :hoverIcon="addIconHover" @btnClick="addClick" class="add-btn" />
        <div class="widget-thumbnails" :class="{ 'can-hide-mode': !isEmpty }" v-if="isShowWidget">
            <ul class="thumb-list">
                <li v-for="(tb, idx) in widgets" class="thumbnail" :key="idx" @click="widgetClick(tb)">
                    <i class="thumb-icon" :style="{ background: tb.icon }"></i>
                    <div class="thumb-text">{{ tb.text }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { uniqueId } from "@/views/zhiji/js/common/util.js";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import i18n from "@/i18n";

export default {
    name: "GuideMore",
    props: ["isEmpty"],
    components: {
        Button
    },
    data() {
        return {
            addIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -56px 0",
            addIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -56px -22px",
            widgetShow: false
        };
    },
    computed: {
        isShowWidget() {
            return this.isEmpty || this.widgetShow;
        },
        selectLabel() {
            return this.$t("zhiji.answer.selectWidgets");
        },
        addLabel() {
            return this.$t("zhiji.answer.addWidget");
        },
        widgets() {
            return getWidgets(this.zhiji.staticPath());
        }
    },
    methods: {
        addClick() {
            this.widgetShow = !this.widgetShow;
        },
        widgetClick(widget) {
            this.$emit("addContent", {
                uId: uniqueId(),
                updateState: "add",
                wtType: widget.wtType,
                image: "",
                content: "",
                float: "mid"
            });

            this.widgetShow = false;
        },
        windowClick(event) {
            if (this.isShowWidget && !this.isEmpty && this.zhiji.isClickOuter(event, "guide-answer-wrapper")) {
                this.widgetShow = false;
            }
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    }
};

function getWidgets(staticPath) {
    return [
        {
            wtType: "GuideText",
            icon: "url('" + staticPath + "ico-mod-txt.png') no-repeat",
            text: i18n.t("zhiji.answer.text")
        },
        {
            wtType: "GuidePicture",
            icon: "url('" + staticPath + "ico-mod-img.png') no-repeat",
            text: i18n.t("zhiji.answer.picture")
        }
    ];
}
</script>

<style lang="scss" scoped>
.guide-answer-wrapper {
    position: relative;
    width: max-content;
    margin-bottom: 120px;

    &.can-hide-mode {
        margin-left: 35px;
        margin-top: 16px;
    }

    .widget-title {
        font-size: 14px;
        margin: 20px 0 12px 12px;
        font-weight: bold;
    }

    .widget-thumbnails {
        margin-left: 12px;

        &.can-hide-mode {
            position: absolute;
            bottom: -110px;
            z-index: 1;
            left: 0;
            max-width: 608px;
            width: max-content;
            padding: 16px 8px 8px 16px;
            margin: 12px 0 0 0;
            margin-left: 0;
            background: #fff;
            border-radius: 4px;
            box-sizing: border-box;
            box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
        }
    }

    .thumb-list {
        font-size: 0;
        padding: 0;
        .thumb-text {
            padding: 5px;
        }
    }

    .thumbnail {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        margin: 0 8px 8px 0;
        min-width: 65px;
        height: 65px;
        border: 1px solid #d8e4f0;
        box-sizing: border-box;
        background: #fff;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;

        &:hover {
            box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
        }
    }

    .thumb-icon {
        display: inline-block;
        width: 30px;
        height: 30px;
        margin-top: 8px;
    }
}
</style>
